export function matchIcon(holiday_label) {
  if (["nikolaus"].includes(holiday_label)) {
    return "🎅";
  }
  if (["weihnachten", "heiligabend"].includes(holiday_label)) {
    return "🎄";
  }
  if (["silvester", "neujahr"].includes(holiday_label)) {
    return "🎆";
  }
  if (["ostern"].includes(holiday_label)) {
    return "🐣";
  }
  return "✨";
}

export function pixelsToRem(px) {
  const rootFontSize = parseFloat(
    getComputedStyle(document.documentElement).fontSize
  );
  return px / rootFontSize;
}
